import { gql } from '@apollo/client';
import { MediaFragment } from 'graphql/Media/fragments/MediaFragment';
/**
 * @fragment DomainFragment
 * @since 1.0.0
 */
export const DomainFragment = gql `
  fragment DomainFragment on Domain {
    id
    name
    host
    href
    website
    options
    createdAt
    updatedAt

    logo {
      ...MediaFragment
    }

    icon {
      ...MediaFragment
    }

    configurationFields {
      id
      fieldKey
      value
    }

    plannedDateInfo {
      hasPlannedDate
      plannedDateMode
    }

    captcha {
      enabled
      provider
      siteKey
    }
  }

  ${MediaFragment}
`;
